export default {
	namespaced: true,
	state: {
		marketplace: {
			enabled: false,
			currentStep: 0,
			steps: [
				{
					id:'gift-options', 
					img: '/wp-content/themes/bookblock-shop/images/worksends/gift-options.png',
					heading: 'Gift Options Filter',
					text: 'Filter through our hand picked range of gift options, by occasion, product type or price point.',
					inMenu: false
				},
				// {
				// 	id:'e-gifts', 
				// 	img: '/wp-content/themes/bookblock-shop/images/worksends/e-gifts.png',
				// 	heading: 'eGifts',
				// 	text: `Browse our extensive range of eGifts, from high street brands such as John Lewis, 
				// 		through to Bloom & Wild and Deliveroo. Choose any voucher value you like.`,
				// 	inMenu: true
				// },
				{
					id:'send-direct', 
					img: '/wp-content/themes/bookblock-shop/images/worksends/send-direct.png',
					heading: 'Send Direct',
					text: `Send your gifts the traditional way by entering their postal address. 
						You can add a branded notecard to any physical gift you send.`,
					inMenu: false
				},
				{
					id:'generate-link', 
					img: '/wp-content/themes/bookblock-shop/images/worksends/generate-link.png',
					heading: 'Generate Link',
					text: `Don't have their address or concerned about GDPR? 
						Generate a unique link to send to your recipient so they can accept the gift and add their address.`,
					inMenu: false
				},
				{
					id:'brand-the-experience', 
					img: '/wp-content/themes/bookblock-shop/images/worksends/brand-the-experience.png',
					heading: 'Brand the Experience',
					text: `Make the experience unique to your brand and customise the claim page, adding your logo and changing the colours.`,
					inMenu: true
				},
				{
					id:'order-history', 
					img: '/wp-content/themes/bookblock-shop/images/worksends/order-history.png',
					heading: 'Order History',
					text: `Get live tracking on all your orders and download detailed CSVs to keep your finance team happy.`,
					inMenu: true
				},
				{
					id:'preferences', 
					img: '/wp-content/themes/bookblock-shop/images/worksends/preferences.png',
					heading: 'Preferences',
					text: `Take full control of your account and add your custom notecard design in the preferences section.`,
					inMenu: true
				},
				{
					id:'campaigns', 
					img: '/wp-content/themes/bookblock-shop/images/worksends/campaigns.png',
					heading: 'Campaigns',
					text: `Upgrade your account, get access to our campaign section and unlock a world of great features, 
						including incentive gifts for sales, surveys and much more.`,
					inMenu: true
				},
				{
					id:'corporate-products', 
					img: '/wp-content/themes/bookblock-shop/images/worksends/corporate-products.png',
					heading: 'Corporate Products',
					text: `We can also make a range of branded product for you that we can hold in stock, 
						ready to be sent anytime you need them.`,
					inMenu: true
				}
			]
		}
	},
	getters: {
		getActiveTutorial(state) {
			for (const tutorial in state) {
				if (state[tutorial].enabled) return tutorial;
			}
		}
	},
	mutations: {
		showTutorial(state, tutorial) {
			state[tutorial].enabled = true;
		},
		hideTutorial(state, tutorial) {
			state[tutorial].enabled = false;
		},
		resetTutorial(state, tutorial) {
			state[tutorial].currentStep = 0;
		},
		setStep(state, pld) {
			state[pld.tutorial].currentStep = pld.step;
		},
		nextStep(state, tutorial) {
			state[tutorial].currentStep++;
		},
		previousStep(state, tutorial) {
			state[tutorial].currentStep--;
		}
	},
	actions: {
		startTutorial({ commit }, tutorial) {
			commit('closeTutorialModal', null, { root: true });
			commit('showTutorial', tutorial);
			commit('resetTutorial', tutorial);
		},
	}
};